import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { INTRO_CATEGORIES, APPSTORE_URL } from '../../data/introFeatures';
import logoLine from '../../images/logo/logo_line.svg';
import './IntroNav.scss';

const IntroNav = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="intro-nav">
            <div className="intro-nav__inner">
                <Link to="/intro" className="intro-nav__logo">
                    <img src={logoLine} alt="온리플" className="intro-nav__logo-img" />
                </Link>

                <button
                    type="button"
                    className="intro-nav__toggle"
                    aria-label="메뉴 열기"
                    onClick={() => setOpen(o => !o)}
                >
                    <FeatherIcon icon={open ? 'x' : 'menu'} size="20" />
                </button>

                <nav className={`intro-nav__menu ${open ? 'is-open' : ''}`}>
                    {INTRO_CATEGORIES.map(c => (
                        <NavLink
                            key={c.slug}
                            to={`/intro/${c.slug}`}
                            className="intro-nav__item"
                            activeClassName="is-active"
                            onClick={() => setOpen(false)}
                        >
                            {c.title}
                        </NavLink>
                    ))}
                </nav>

                <div className={`intro-nav__cta ${open ? 'is-open' : ''}`}>
                    <Link to="/signIn" className="intro-nav__login">로그인</Link>
                    <a
                        href={APPSTORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="intro-nav__start"
                    >
                        시작하기 <FeatherIcon icon="external-link" size="13" />
                    </a>
                </div>
            </div>
        </header>
    );
};

export default IntroNav;
